import * as React from 'react';
import { Avatar, Button, CssBaseline, TextField, Link, Grid2, Box, Typography, Container } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import logo from '../../images/Logo.png'
import Loading from '../setup/Loading'
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import ErrorMsg from '../../BuiltInComponent/ErrorMsg'

import { login } from '../../features/auth/authSlice'

export default function Login() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { user, isLoading } = useSelector(state => state.auth)

    const [userData, setUserData] = React.useState({
        userName: '',
        userPassword: ''
    })

    const handleOnChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        })
    }

    React.useEffect(() => {
        if (user) {
            if (!user.message || user.message.includes('successful')) {
                navigate('/POS')
            }
        }
    }, [user, navigate])

    const loginUser = (e) => {
        e.preventDefault()
        console.log('reach')
        console.log(userData)
        dispatch(login(userData))
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {/* <img src={logo} height={70} width={70} alt='' onClick={() => navigate("/")} /> */}
                <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                {isLoading ? (<Loading />) : (<></>)}
                {/* {errMsg ? (<Typography style={{
                    backgroundColor: 'red',
                    padding: 10,
                    margin: 10,
                    borderRadius: 20,
                    color: 'white',
                    minWidth: 250,
                    textAlign: 'center'
                }}>
                    {errMsg}
                </Typography>) : (<></>)} */}
                <Box component="form" onSubmit={loginUser} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="userName"
                        label="Enter User ID"
                        name="userName"
                        autoComplete="userName"
                        autoFocus
                        onChange={handleOnChange}
                    // onFocus={() => setErrorMessage('')}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="userPassword"
                        label="Password"
                        type="Password"
                        id="userPassword"
                        autoComplete="userPassword"
                        onChange={handleOnChange}
                    // onFocus={() => setErrorMessage('')}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Sign In
                    </Button>
                    <Grid2 container>
                        <Grid2 size={12}>
                            {global.msgError !== '' ?
                                <ErrorMsg message={global.msgError} msgColor='red' /> : <></>}

                        </Grid2>
                        <Grid2 xs>
                            <Link href="/" variant="body2">
                                Forgot password?
                            </Link>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </Container>
    );
}